import React, {useEffect, useState, useLayoutEffect, useRef} from 'react';
import {
  View,
  Platform,
  BackHandler,
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  Pressable,
  ActivityIndicator,
} from 'react-native';

import {
  useNavigation,
  useRoute,
  CommonActions,
} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {RNEButton, RNEText} from '../../components';
import {colorPalette, colors} from '../../../core/config/color.config';
import {Icon, makeStyles, Overlay} from 'react-native-elements'; // rne-netzon replaced
import {useCancelConsultationDetail} from '../../server/react-query/useConsultation';

import useStores from '../../stores/useStores';
import {width, height, totalSize} from 'react-native-dimension';
import ConsultationCancelConfirmationModal from '../../views/modal/ConsultationCancelConfirmationModal';

import {
  ConsultationAcceptDecline,
  ConsultationCancel,
  ConsultationChat,
  ConsultationDetailEntry,
  ConsultationDetailPlaceholder,
  ConsultationDoctorPopover,
  ConsultationDoctorProfileModal,
  ConsultationEndModal,
  ConsultationPatientMedicalModal,
  ConsultationPatientPopover,
  ConsultationStatus,
  ConsultationHistoryFooterNote,
  ContentScrollView,
  HeaderConsultationDoctor,
  HeaderConsultationDoctorWeb,
  HeaderConsultationPatient,
  HeaderConsultationPatientWeb,
  MedicalAttachmentsListView,
  ConsultationProceedToPayment,
} from '../../views';

import {
  useGetConsultationDetail,
  useMarkAsReadConsultation,
} from '../../server/react-query/useConsultation';
import {ConsultationStatusEnum} from '../../server/types/consultation.types';

import useConversation from '../../hooks/conversation/useConversation';

import {PopoverItemKey} from '../../views/popover/data/popoverItems.data';
import MedicalAttachmentsModal from '../../views/modal/MedicalAttachmentsModal';
import {MedicalAttachmentEnum} from '../../views/medical-attachments/data/medicalAttachment';
import {computeAge} from '../../utils/date.utils';
import {useGetAllMedicalAttachments} from '../../server/react-query/useMedicalAttachment';
import EmptyMedicalAttachmentsModal from '../../views/modal/EmptyMedicalAttachmentsModal';
import {ProcedureStatusEnum} from '../../server/types/procedure.types';
import useVideoCall from '../../hooks/video-call/useVideoCall';
import {REACT_APP_BASE_WEB_URL} from '../../server/api/api.config';
import moment from 'moment';
import {useToast} from 'react-native-fast-toast';

const ConsultationDetailScreen = () => {
  const route = useRoute();
  const navigation = useNavigation();
  const {authStore, patientProfileStore, doctorProfileStore} = useStores();
  const {closeRoom, resetValues} = useVideoCall();

  const {initialized, conversation, resetConversation, getConversation} = useConversation();
  const toast = useToast();

  const [showIncorrectProfileDialog, setShowIncorrectProfileDialog] =
    useState(false);

  const [consultationId, setConsultationId] = useState();
  const [showEndConsultationDialog, setShowEndConsultationDialog] =
    useState(false);
  const [showMedicalAttachmentsDialog, setShowMedicalAttachmentsDialog] =
    useState(false);
  const [
    showEmptyMedicalAttachmentsDialog,
    setShowEmptyMedicalAttachmentsDialog,
  ] = useState(false);
  const [showMedicalAttachmentsScreen, setShowMedicalAttachmentsScreen] =
    useState(false);
  const [showViewDoctorProfileDialog, setShowViewDoctorProfileDialog] =
    useState(false);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [statusByPatient, setStatusByPatient] = useState(false);
  const [isArchiveConfirmModalVisible, setIsArchiveConfirmModalVisible] =
    useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [doctorHasMessaged, setDoctorHasMessaged] = useState(false);

  const {data: serviceRequest, isLoading} = useGetConsultationDetail({
    serviceRequestId: consultationId || '',
  });

  const {mutate: markAsReadMutate} = useMarkAsReadConsultation();

  const {data: medicalAttachments, refetch} = useGetAllMedicalAttachments({
    serviceRequestId: consultationId,
  });

  const archieveMutation = useCancelConsultationDetail({
    serviceRequestId: serviceRequest?.serviceRequestId,
    status: ConsultationStatusEnum.ARCHIVED,
  });

  const [navProps, setNavProps] = useState(null);
  const [notificationProps, setNotificationProps] = useState();
  const consultationRouteParams: any = route.params;
  const isNotificationOrigin = Boolean(
    consultationRouteParams?.fromNotifications,
  );

  useEffect(() => {
    if (serviceRequest) {
      // console.log(serviceRequest)
      setNavProps({
        procedureId: serviceRequest?.procedure?.procedureId,
        subjectId: serviceRequest?.subject?.patientId,
        receiver:
          authStore.authData?.user.userRole === 'patient'
            ? serviceRequest?.procedure?.subject
            : serviceRequest?.procedure?.performer,
        serviceRequestId: serviceRequest?.serviceRequestId,
      });

      setNotificationProps({
        title:
          authStore.authData?.user.userRole === 'patient'
            ? 'New chat message for the doctor'
            : 'New chat message for the patient',
        body: 'Your consultation chat has a new message',
        consultation: `"${JSON.stringify(navProps)}"`,
        notificationUrl: `${REACT_APP_BASE_WEB_URL}main/consultation/detail?id=${consultationId}&screen=pending&tab=0`,
        fromUserId: authStore.authData?.user.userId!,
        toUserId:
          authStore.authData?.user.userRole === 'patient'
            ? serviceRequest?.performer.userId!
            : serviceRequest?.requester!,
        toEntityType: authStore.authData?.user.userRole === 'patient' ? 'practitioner' : 'patient',
        toEntityId: authStore.authData?.user.userRole === 'patient'
            ? serviceRequest?.performer.practitionerId!
            : serviceRequest?.subject?.patientId!,
      });
    }
  }, [serviceRequest]);

  const onMenuItemClick = async (itemKey: PopoverItemKey) => {
    let defaultAttachValues;
    if (
      serviceRequest &&
      serviceRequest.subject &&
      (serviceRequest.status === ConsultationStatusEnum.COMPLETED ||
        serviceRequest.status === ConsultationStatusEnum.ONGOING)
    ) {
      // console.log('serviceRequest', JSON.stringify(serviceRequest), 'serviceRequest');
      defaultAttachValues = {
        basedOnId: serviceRequest?.serviceRequestId,
        subject: serviceRequest?.subject.patientId,
        patientName: `${serviceRequest?.subject.humanName.given[0]} ${serviceRequest?.subject.humanName.family}`,
        age:
          serviceRequest?.subject.birthdate &&
          computeAge(serviceRequest?.subject.birthdate),
        userId: serviceRequest.subject.userId,
      };
    }

    switch (itemKey) {
      case PopoverItemKey.END_CONSULTATION:
        handleEndConsultation();
        break;

      case PopoverItemKey.MEDICAL_ATTACHMENTS:
        const res = await refetch();
        if (res.data && res.data?.length > 0) {
          if (Platform.OS === 'web') {
            setShowMedicalAttachmentsDialog(true);
          } else {
            setShowMedicalAttachmentsScreen(true);
          }
        } else {
          setShowEmptyMedicalAttachmentsDialog(true);
        }
        break;

      case PopoverItemKey.DOCTOR_PROFILE:
        handleViewDoctorProfile();
        break;

      case PopoverItemKey.MEDICAL_HISTORY:
        handleViewHistory();
        break;

      case PopoverItemKey.LABORATORY_REQUEST:
        navigation.navigate(NavigationKey.DOCTOR_ADD_MEDICAL_ATTACHMENT, {
          view: MedicalAttachmentEnum.LABORATORY_REQUEST,
          ...defaultAttachValues,
        });
        break;

      case PopoverItemKey.MEDICAL_CERTIFICATE:
        navigation.navigate(NavigationKey.DOCTOR_ADD_MEDICAL_ATTACHMENT, {
          view: MedicalAttachmentEnum.MEDICAL_CERTIFICATE,
          ...defaultAttachValues,
        });
        break;

      case PopoverItemKey.PRESCRIPTION:
        navigation.navigate(NavigationKey.DOCTOR_ADD_MEDICAL_ATTACHMENT, {
          view: MedicalAttachmentEnum.PRESCRIPTION,
          ...defaultAttachValues,
        });
        break;

      default:
        break;
    }
  };

  const handleEndConsultation = () => {
    setShowEndConsultationDialog(true);
  };

  const endConsultationCancel = () => {
    setShowEndConsultationDialog(false);
  };

  const endConsultationComplete = () => {
    setShowEndConsultationDialog(false);
    navigation.navigate(NavigationKey.DOCTOR_CONSULTATION_STACK, {
      screen: NavigationKey.CONSULTATION_LIST,
      params: {
        tab: 2,
        id: serviceRequest?.serviceRequestId,
      },
    });
  };

  const handleViewDoctorProfile = () => {
    if (Platform.OS === 'web') {
      setShowViewDoctorProfileDialog(true);
    } else {
      setShowMedicalAttachmentsScreen(false);
      if (serviceRequest) {
        navigation.navigate(NavigationKey.CONSULTATION_DOCTOR_PROFILE, {
          practitioner: serviceRequest?.performer,
        });
      }
    }
  };

  const handleViewHistory = () => {
    if (Platform.OS === 'web') {
      setShowHistoryDialog(true);
    } else {
      if (serviceRequest) {
        navigation.navigate(
          NavigationKey.CONSULTATION_PATIENT_MEDICAL_HISTORY,
          {
            patient: serviceRequest.subject,
            status: serviceRequest.status,
          },
        );
      }
    }
  };

  const sendMessage = (message: string) => {
    setShowMedicalAttachmentsScreen(false);

    console.log('Initialized:', initialized);
    // console.log('Conversation:', conversation);

    if (initialized && conversation) {
      conversation.sendMessage(message);
    } else {
      toast?.show('Chat is unavailable in local mode.', {
        type: 'warning',
      });
    }
  };

  useEffect(() => {
    if (initialized && serviceRequest?.procedure?.procedureId) {
      setDoctorHasMessaged(false);
    }
  }, [initialized, serviceRequest?.procedure?.procedureId]);

  useEffect(() => {
    if (!conversation || authStore.userRole !== 'patient') {
      return;
    }

    const patientId = patientProfileStore.activeProfile?.patientId;

    const checkDoctorMessages = async () => {
      try {
        const msgs = await conversation.getMessages(50);
        const hasDoctorMsg = msgs.items.some(
          (msg: any) => msg.author !== patientId,
        );
        setDoctorHasMessaged(hasDoctorMsg);
      } catch {
        // Conversation may not be ready yet
      }
    };

    checkDoctorMessages();

    const onMessageAdded = (msg: any) => {
      if (msg.author !== patientId) {
        setDoctorHasMessaged(true);
      }
    };

    conversation.on('messageAdded', onMessageAdded);

    return () => {
      conversation.removeListener?.('messageAdded', onMessageAdded);
    };
  }, [conversation, authStore.userRole, patientProfileStore.activeProfile?.patientId]);

  const navigateBackToTab = (consultationStatus?: ConsultationStatusEnum) => {
    if (isNotificationOrigin) {
      const notificationStack =
        authStore.userRole === 'patient'
          ? NavigationKey.PATIENT_NOTIFICATION_STACK
          : NavigationKey.DOCTOR_NOTIFICATION_STACK;

      // Pop the consultation detail off the stack so it won't remain when
      // the user navigates to Consultations from the menu later.
      if (navigation.canGoBack()) {
        navigation.dispatch(CommonActions.reset({
          index: 0,
          routes: [{name: NavigationKey.CONSULTATION_LIST}],
        }));
      }

      // Navigate to notification stack
      setTimeout(() => {
        navigation.navigate(notificationStack as never);
      }, 0);
      return;
    }

    let screen: NavigationKey;

    switch (consultationStatus) {
      case ConsultationStatusEnum.PENDING:
        screen = NavigationKey.CONSULTATION_TAB_PENDING;
        break;

      case ConsultationStatusEnum.ONGOING:
        screen = NavigationKey.CONSULTATION_TAB_ONGOING;
        break;

      case ConsultationStatusEnum.CANCELLED:
      case ConsultationStatusEnum.COMPLETED:
      case ConsultationStatusEnum.DECLINED:
        screen = NavigationKey.CONSULTATION_TAB_HISTORY;
        break;

      default:
        screen = NavigationKey.CONSULTATION_TAB_ONGOING;
        break;
    }

    if (screen) {
      navigation.navigate(NavigationKey.DOCTOR_CONSULTATION_STACK, {
        screen: NavigationKey.CONSULTATION_LIST,
        params: {
          screen: screen,
        },
      });
    }
  };

  const endCall = async (subjectId: string, roomId: string) => {
    await closeRoom(subjectId, roomId);
    resetValues();
  };

  useEffect(() => {
    const patientId = patientProfileStore.activeProfile?.patientId;
    const doctor = doctorProfileStore.doctorStatus;
    if (consultationRouteParams?.id) {
      setShowIncorrectProfileDialog(false);
    } else if (
      consultationRouteParams?.subjectId !== undefined &&
      consultationRouteParams?.subjectId !== patientId &&
      !doctor
    ) {
      setShowIncorrectProfileDialog(true);
    }
    if (consultationRouteParams || consultationRouteParams?.params) {
      setConsultationId(
        consultationRouteParams?.id || consultationRouteParams?.params?.id,
      );

      if (consultationRouteParams?.declining) {
        endCall(
          consultationRouteParams?.subjectId,
          consultationRouteParams?.roomId,
        );
      }

      if (consultationRouteParams?.id !== consultationId) {
        resetConversation();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consultationRouteParams]);

  useEffect(() => {
    if (Platform.OS !== 'android') {
      return;
    }

    const onHardwareBackPress = () => {
      if (showMedicalAttachmentsScreen) {
        setShowMedicalAttachmentsScreen(false);
        return true;
      }

      if (!isNotificationOrigin) {
        return false;
      }

      navigateBackToTab(serviceRequest?.status);
      return true;
    };

    const subscription = BackHandler.addEventListener(
      'hardwareBackPress',
      onHardwareBackPress,
    );

    return () => subscription.remove();
  }, [
    isNotificationOrigin,
    serviceRequest?.status,
    showMedicalAttachmentsScreen,
  ]);

  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', event => {
      if (!isNotificationOrigin || showMedicalAttachmentsScreen) {
        return;
      }

      if (
        event.data.action.type !== 'GO_BACK' &&
        event.data.action.type !== 'POP' &&
        event.data.action.type !== 'POP_TO_TOP'
      ) {
        return;
      }

      event.preventDefault();
      navigateBackToTab(serviceRequest?.status);
    });

    return unsubscribe;
  }, [
    isNotificationOrigin,
    navigation,
    serviceRequest?.status,
    showMedicalAttachmentsScreen,
  ]);

  useEffect(() => {
    if (consultationId) {
      // console.log('HIIIT',consultationId)
      markAsReadMutate({serviceRequestId: consultationId});
    }
  }, [consultationId]);

  useEffect(() => {
    switch (authStore.userRole) {
      case 'patient':
        setStatusByPatient(
          authStore.auth?.user.userId === serviceRequest?.modifiedBy,
        );
        break;

      case 'practitioner':
        setStatusByPatient(
          !(authStore.auth?.user.userId === serviceRequest?.modifiedBy),
        );
        break;

      default:
        break;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.userRole, serviceRequest]);

  useEffect(() => {
    const id = serviceRequest?.serviceRequestId;
    let params = {};

    if (id) {
      switch (serviceRequest?.status) {
        case ConsultationStatusEnum.ONGOING:
          params = {
            tab: 0,
            screen: NavigationKey.CONSULTATION_TAB_ONGOING,
            id: id,
          };
          break;

        case ConsultationStatusEnum.PENDING:
          params = {
            tab: 1,
            screen: NavigationKey.CONSULTATION_TAB_PENDING,
            id: id,
          };
          break;

        case ConsultationStatusEnum.COMPLETED:
        case ConsultationStatusEnum.DECLINED:
        case ConsultationStatusEnum.CANCELLED:
        case ConsultationStatusEnum.ARCHIVED:
          params = {
            tab: 2,
            screen: NavigationKey.CONSULTATION_TAB_HISTORY,
            id: id,
          };
          break;
      }

      navigation.setParams(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceRequest?.status]);

  useLayoutEffect(() => {
    if (Platform.OS !== 'web') {
      navigation.setOptions({
        title: '',
        headerLeft: () => {
          if (authStore.userRole === 'patient') {
            return (
              <HeaderConsultationDoctor
                serviceRequest={serviceRequest}
                onBackClickFromList={() => {
                  showMedicalAttachmentsScreen
                    ? setShowMedicalAttachmentsScreen(false)
                    : navigateBackToTab(serviceRequest?.status);
                }}
              />
            );
          } else if (authStore.userRole === 'practitioner') {
            return (
              <HeaderConsultationPatient
                serviceRequest={serviceRequest}
                onBackClickFromList={() => {
                  showMedicalAttachmentsScreen
                    ? setShowMedicalAttachmentsScreen(false)
                    : navigateBackToTab(serviceRequest?.status);
                }}
              />
            );
          } else {
            null;
          }
        },
        headerRight: () => (
          <View
            style={[
              styles.headerRight,
              {
                right:
                  serviceRequest?.status === ConsultationStatusEnum.PENDING
                    ? -width(2.5)
                    : -width(12),
              },
            ]}>
            {!(
              serviceRequest?.status === ConsultationStatusEnum.ONGOING ||
              serviceRequest?.status === ConsultationStatusEnum.COMPLETED
            ) && (
              <ConsultationStatus
                consultationStatus={serviceRequest?.status}
                procedureStatus={serviceRequest?.procedure?.status}
                isActionByPatient={statusByPatient}
              />
            )}

            {(serviceRequest?.status === ConsultationStatusEnum.ONGOING ||
              serviceRequest?.status === ConsultationStatusEnum.COMPLETED) &&
              authStore.userRole === 'patient' &&
              !!serviceRequest && (
                <>
                  <View
                    style={{
                      width: width(40),
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: totalSize(1.5),
                      paddingRight: width(5),
                    }}>
                    {serviceRequest?.status ===
                    ConsultationStatusEnum.ONGOING ? (
                      <>
                        <View>
                          <Text
                            style={{
                              color: colors.mediumTurquoise.regular,
                              fontSize: totalSize(1.4),
                              fontFamily: 'Quicksand-Bold',
                            }}>
                            On Going
                          </Text>
                        </View>
                        <ConsultationPatientPopover
                          status={serviceRequest.status}
                          onMenuItemClick={onMenuItemClick}
                        />
                      </>
                    ) : (
                      <View style={{width: width(22), alignItems: 'flex-end'}}>
                        <ConsultationPatientPopover
                          status={serviceRequest.status}
                          onMenuItemClick={onMenuItemClick}
                        />
                      </View>
                    )}
                  </View>
                </>
              )}

            {(serviceRequest?.status === ConsultationStatusEnum.ONGOING ||
              serviceRequest?.status === ConsultationStatusEnum.COMPLETED) &&
              authStore.userRole === 'practitioner' && (
                <View
                  style={{
                    width: width(25),
                    alignItems: 'center',
                    paddingRight:
                      Platform.OS === 'android' ? width(16) : width(14),
                  }}>
                  <ConsultationDoctorPopover
                    status={serviceRequest.status}
                    onMenuItemClick={onMenuItemClick}
                  />
                </View>
              )}
          </View>
        ),
        headerStyle: {
          borderBottomColor: colorPalette.light,
          borderBottomWidth: width(0.2),
          elevation: 0,
          shadowOpacity: 0,
          height: Platform.OS === 'ios' ? height(12) : height(8),
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    navigation,
    serviceRequest,
    authStore.userRole,
    statusByPatient,
    showMedicalAttachmentsScreen,
  ]);

  const handleArchiveRequest = async () => {
    try {
      setIsBtnLoading(true);
      await archieveMutation.mutateAsync();
      setIsArchiveConfirmModalVisible(false);
      setTimeout(() => {
        setIsBtnLoading(false);
      }, 1000);
    } catch (error) {
      setIsBtnLoading(false);
    }
  };

  const [isAgoraLoaderVisible, setIsAgoraLoaderVisible] = useState(false);

  const onStartGenerating = () => {
    setIsAgoraLoaderVisible(true);
  };

  const onStopGenerating = () => {
    setIsAgoraLoaderVisible(false);
  };

  return (
    <>
    {isAgoraLoaderVisible && (
        <View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
          pointerEvents="auto" // block touches
        >
          <ActivityIndicator size="large" color="#fff" />
        </View>
      )}
      <View style={styles.root}>
        <Overlay
          onBackdropPress={() => null}
          isVisible={showIncorrectProfileDialog}
          overlayStyle={rneStyles.overlayContainer}>
          <View style={rneStyles.root}>
            <RNEText
              label="Incorrect Profile"
              variant="title"
              align="center"
              weight="600"
              color="accent"
            />
            <View style={rneStyles.subtitleContainer}>
              <RNEText
                label="You may switch profile to view notification."
                variant="body"
                align="center"
              />
            </View>
            <View style={rneStyles.actionContainer}>
              <RNEButton
                title="Switch Profiles"
                color="accent"
                onPress={() => {
                  setShowIncorrectProfileDialog(false);
                  navigation.navigate(NavigationKey.PATIENT_PROFILE_STACK);
                }}
                style={rneStyles.buttonStyle}
              />
            </View>
          </View>
        </Overlay>
        <Overlay
          onBackdropPress={() => setShowMedicalAttachmentsDialog(false)}
          isVisible={showMedicalAttachmentsDialog}
          overlayStyle={styles.overlayContainer}>
          <MedicalAttachmentsModal
            basedOnId={serviceRequest?.serviceRequestId}
            subject={
              serviceRequest?.subject && serviceRequest?.subject.patientId
            }
            serviceRequestId={serviceRequest?.serviceRequestId}
            attachments={medicalAttachments}
          />
        </Overlay>
        <Overlay
          isVisible={showEmptyMedicalAttachmentsDialog}
          overlayStyle={styles.overlayContainer}>
          <EmptyMedicalAttachmentsModal
            onConfirm={() => setShowEmptyMedicalAttachmentsDialog(false)}
          />
        </Overlay>
        {consultationId ? (
          <View style={styles.content}>
            <View
              style={{flex: 1, paddingRight: width(1), paddingLeft: width(1)}}>
              {Platform.OS === 'web' && (
                <>
                  <View
                    style={
                      authStore.userRole === 'patient'
                        ? styles.boxHeaderPatient
                        : styles.boxHeaderDoctor
                    }
                  />
                  <View style={styles.contentLimit}>
                    {authStore.userRole === 'patient' && (
                      <HeaderConsultationDoctorWeb
                        serviceRequest={serviceRequest}
                        onMenuItemClick={onMenuItemClick}
                      />
                    )}

                    {authStore.userRole === 'practitioner' && (
                      <HeaderConsultationPatientWeb
                        serviceRequest={serviceRequest}
                        onMenuItemClick={onMenuItemClick}
                      />
                    )}
                  </View>
                </>
              )}

              {showMedicalAttachmentsScreen && Platform.OS !== 'web' && (
                <View style={styles.listContainer}>
                  <MedicalAttachmentsListView
                    serviceRequestId={serviceRequest?.serviceRequestId}
                    subject={
                      serviceRequest?.subject &&
                      serviceRequest?.subject.patientId
                    }
                    attachments={medicalAttachments}
                  />
                </View>
              )}

              {!showMedicalAttachmentsScreen && (
                <View style={[styles.messages]}>
                  <ContentScrollView
                    isWeb={Platform.OS === 'web'}
                    scrollToEnd={true}>
                    <View style={styles.messagesWrapper}>
                      <View
                        style={[
                          styles.contentLimit,
                          authStore.userRole === 'practitioner' &&
                            (serviceRequest?.status ===
                              ConsultationStatusEnum.COMPLETED ||
                              serviceRequest?.status ===
                                ConsultationStatusEnum.CANCELLED) && {
                              marginBottom: height(10),
                            },
                        ]}>
                        {serviceRequest && !isLoading ? (
                          <ConsultationDetailEntry
                            serviceRequest={serviceRequest}
                            onStartGenerating={onStartGenerating}
                            onStopGenerating={onStopGenerating}
                          />
                        ) : (
                          <View style={styles.contentPlaceholder}>
                            <RNEButton
                              height={32}
                              loadingProps={loadingPropsStyle}
                              loading={true}
                            />
                            <RNEText
                              label="Getting your messages..."
                              color="grey"
                              align="center"
                            />
                          </View>
                        )}
                      </View>
                    </View>
                  </ContentScrollView>
                </View>
              )}
            </View>

            {serviceRequest && (
              <View style={styles.contentLimit}>
                {serviceRequest?.status === ConsultationStatusEnum.PENDING &&
                  !serviceRequest.procedure &&
                  authStore.userRole === 'patient' && (
                    <ConsultationCancel
                      serviceRequestId={serviceRequest?.serviceRequestId}
                    />
                  )}

                {serviceRequest?.status === ConsultationStatusEnum.PENDING &&
                  serviceRequest?.procedure?.status ===
                    ProcedureStatusEnum.TO_PAY &&
                  authStore.userRole === 'patient' && (
                    <ConsultationProceedToPayment
                      serviceId={serviceRequest?.procedure.procedureId}
                      serviceRequestId={serviceRequest?.serviceRequestId}
                      patientId={serviceRequest?.subject.patientId}
                    />
                  )}

                {serviceRequest?.status === ConsultationStatusEnum.PENDING &&
                  !serviceRequest.procedure &&
                  authStore.userRole === 'practitioner' &&
                  serviceRequest?.subject && (
                    <ConsultationAcceptDecline
                      serviceRequest={serviceRequest}
                    />
                  )}
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: totalSize(0.5),
                  }}>
                  {authStore.userRole === 'practitioner' &&
                    (serviceRequest?.status ===
                      ConsultationStatusEnum.COMPLETED ||
                      serviceRequest?.status ===
                        ConsultationStatusEnum.CANCELLED) && (
                      <View
                        style={{
                          paddingTop: totalSize(1.5),
                          paddingBottom: totalSize(1.5),
                          position: 'absolute',
                          bottom: height(10),
                          justifyContent: 'center',
                          alignContent: 'center',
                          alignItems: 'center',
                          alignSelf: 'center',
                        }}>
                        <Pressable
                          onPress={() =>
                            setIsArchiveConfirmModalVisible(
                              !isArchiveConfirmModalVisible,
                            )
                          }>
                          <View
                            style={[styles.container, styles.archiveContainer]}>
                            <View style={styles.btnContainer}>
                              <Text style={styles.btnTxtStyle}>Archive</Text>
                            </View>
                          </View>
                        </Pressable>
                      </View>
                    )}

                  {(serviceRequest?.status ===
                    ConsultationStatusEnum.COMPLETED ||
                    serviceRequest?.status ===
                      ConsultationStatusEnum.CANCELLED ||
                    serviceRequest?.status ===
                      ConsultationStatusEnum.ARCHIVED ||
                    !serviceRequest?.subject) && (
                    <ConsultationHistoryFooterNote
                      serviceRequest={serviceRequest}
                    />
                  )}
                </View>
              </View>
            )}

          

            {serviceRequest &&
              serviceRequest.subject &&
              serviceRequest?.status === ConsultationStatusEnum.ONGOING &&
              (authStore.userRole !== 'patient' || doctorHasMessaged) && (
                <KeyboardAvoidingView
                  style={Platform.OS === 'web' && fullWidthWeb}
                  behavior={Platform.OS === 'ios' ? 'padding' : undefined}
                  keyboardVerticalOffset={80}>
                  <View
                    style={[
                      styles.contentLimit,
                      Platform.OS !== 'web' && styles.contentLimitChat,
                    ]}>
                    <ConsultationChat
                      notificationProps={notificationProps}
                      consultation={serviceRequest}
                      onSend={sendMessage}
                      userRole={authStore.userRole}
                      onMenuItemClick={onMenuItemClick}
                    />
                  </View>
                </KeyboardAvoidingView>
              )}
          </View>
        ) : (
          <View style={styles.detailPlaceholder}>
            <ConsultationDetailPlaceholder />
          </View>
        )}
      </View>

      <Overlay
        isVisible={showEndConsultationDialog && !!serviceRequest}
        overlayStyle={styles.overlayContainer}
        onBackdropPress={() => setShowEndConsultationDialog(false)}>
        {!!serviceRequest && (
          <ConsultationEndModal
            serviceRequest={serviceRequest}
            onCancel={endConsultationCancel}
            onComplete={endConsultationComplete}
          />
        )}
      </Overlay>

      <Overlay
        isVisible={showViewDoctorProfileDialog && !!serviceRequest}
        overlayStyle={styles.overlayContainer}
        onBackdropPress={() => setShowViewDoctorProfileDialog(false)}>
        {!!serviceRequest && (
          <ConsultationDoctorProfileModal
            practitioner={serviceRequest.performer}
            onClose={() => setShowViewDoctorProfileDialog(false)}
          />
        )}
      </Overlay>

      <Overlay
        isVisible={showHistoryDialog && !!serviceRequest}
        overlayStyle={[
          styles.overlayContainer,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            padding: 0,
          },
        ]}
        onBackdropPress={() => setShowHistoryDialog(false)}>
        {!!serviceRequest && (
          <ConsultationPatientMedicalModal
            patient={serviceRequest.subject}
            status={serviceRequest.status}
            onClose={() => setShowHistoryDialog(false)}
          />
        )}
      </Overlay>

      <Overlay
        isVisible={isArchiveConfirmModalVisible}
        overlayStyle={styles.overlayContainer}>
        <ConsultationCancelConfirmationModal
          isLoading={isBtnLoading}
          title={'Are you sure you want to archive this consultation?'}
          primaryBtnText={'Yes'}
          secondaryBtnText={'No'}
          onConfirm={handleArchiveRequest}
          onCancel={() => {
            setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible);
          }}
        />
      </Overlay>
    </>
  );
};

const loadingPropsStyle = {
  color: colorPalette.primary,
};

const fullWidthWeb = {
  width: '100%',
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  detailPlaceholder: {
    flex: 1,
    paddingBottom: 60,
  },
  content: {
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  messages: {
    flex: 1,
    width: '100%',
  },
  messagesWrapper: {
    alignItems: 'center',
  },
  headerRight: {
    flexDirection: 'row',
    // paddingHorizontal: 12,
    // paddingHorizontal: -15,
    // paddingRight: width(8),
    position: 'absolute',
  },
  contentLimit: {
    width: '100%',
    paddingHorizontal: width(4),
  },
  contentLimitChat: {
    paddingHorizontal: 0,
  },
  overlayContainer: {
    borderRadius: 20,
    marginHorizontal: 40,
  },
  listContainer: {
    maxWidth: 860,
    width: '100%',
    flex: 1,
  },
  contentPlaceholder: {
    marginTop: 24,
  },
  boxHeaderDoctor: {
    height: 68,
    backgroundColor: colorPalette.success,
    width: '100%',
  },
  boxHeaderPatient: {
    height: 68,
    backgroundColor: colorPalette.primary,
    width: '100%',
  },
  container: {
    borderWidth: totalSize(0.2),
    padding: totalSize(1.5),
    paddingTop: totalSize(1.5),
    paddingBottom: totalSize(1.5),
    paddingRight: width(7.5),
    paddingLeft: width(7.5),
    borderRadius: totalSize(5),
    alignSelf: 'center',
    // position: 'absolute',
    // bottom: totalSize(1.5),
  },
  archiveContainer: {
    borderColor: '#3FB4E6',
    backgroundColor: '#3FB4E6',
  },
  btnContainer: {
    minWidth: Platform.OS === 'android' ? width(14) : width(16),
    maxWidth: Platform.OS === 'android' ? width(14) : width(16),
  },
  btnTxtStyle: {
    textAlign: 'center',
    color: colorPalette.white,
    fontFamily: 'Quicksand-Bold',
    fontSize: totalSize(1.5),
  },
});

const rneStyles = StyleSheet.create({
  root: {
    maxWidth: Platform.OS === 'web' ? 420 : '80%',
    padding: Platform.OS === 'web' ? 32 : 16,
  },
  subtitleContainer: {
    marginTop: 20,
  },
  actionContainer: {
    marginTop: 36,
    alignItems: 'center',
  },
  buttonStyle: {
    width: 200,
  },
  overlayContainer: {
    borderRadius: 20,
    marginHorizontal: 40,
  },
  archivebutton: {
    backgroundColor: '#1E9CE4',
    borderRadius: 30, // pill shape
    paddingVertical: 12,
    paddingHorizontal: 50,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: {width: 0, height: 2},
    shadowRadius: 3,
    elevation: 3,
  },
  archivecontent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  archivetext: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '500',
    marginLeft: 6,
  },
  archiveButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    position: 'absolute',
    bottom: totalSize(11),
    alignSelf: 'center',
    zIndex: 1000,
  },
});

export default ConsultationDetailScreen;
